import React, { FC } from 'react'

import cn from 'classnames'
import { Link } from 'react-router-dom'

import { getDesktopLoggedInMenuItems } from './DesktopMenu.content'
import classes from './DesktopMenu.module.scss'
import { DesktopMenuProps } from './DesktopMenu.types'
// import { useAppDispatch } from '../../../../store'
// import { logoutUser } from '../../../../store/auth/dispatchers/logoutUser'
import MenuItemCommon from '../menu-item'
import commonClasses from '../menu-item/menu-item.module.scss'

const DesktopMenu: FC<DesktopMenuProps> = ({
  isAuthenticated,
  isAbandonedAccount,
  isActivated,
  isNotInGroup,
  userHasUsage,
  userHasAgreement,
  memberWithNickname,
  marketingUrl,
  communityUrl,
  logoutUser,
}) => {
  // const dispatch = useAppDispatch()

  const desktopMenus = getDesktopLoggedInMenuItems({
    isActivated,
    isAbandonedAccount,
    isNotInGroup,
    userHasUsage,
    userHasAgreement,
    memberWithNickname,
    marketingUrl,
    communityUrl,
    logoutUser,
  })

  return (
    <div className={classes.root}>
      {!isAuthenticated && (
        <Link
          to="/login"
          className={classes.logout}
          data-testid="log-in-menu-item"
        >
          Log in
        </Link>
      )}
      {isAuthenticated && (
        <ul className={classes.menuList}>
          {desktopMenus.map((subMenu) => (
            <li
              key={subMenu.id}
              tabIndex={0}
              className={cn(commonClasses.item, classes.item)}
            >
              {subMenu.name}
              <div className={classes.subMenu}>
                {subMenu.items.map((item) => (
                  <MenuItemCommon
                    menuItem={item}
                    className={classes.item}
                    key={item.id}
                  />
                ))}
              </div>
            </li>
          ))}
          <li
            tabIndex={0}
            className={classes.logout}
            onClick={() => logoutUser()}
            data-testid="log-out-menu-item"
          >
            Log out
          </li>
        </ul>
      )}
    </div>
  )
}

export default DesktopMenu
